import { getRequestTitle } from '../../../Request'

export function getServiceRequestListItemProps(value) {
  return {
    description: value.building?.title,
    isArchived: value.archived,
    status: value.status,
    text: getRequestTitle({
      requestNumber: value.request_no,
      title: value.title,
    }),
    value: value.id,
  }
}
